import React, {Component} from 'react';
import {controlMaxWidthStyle, errorMessageStyle} from '../styles';
import AuthenticationService from './authentication-service';

export default class RegistrationForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            firstName: '',
            lastName: '',
            companyName: '',
            role: '',
            telephone: '',
            linkedInProfileUrl: '',
            email: '',
            confirmEmail: '',
            isRegistering: false,
            isRegistered: false,
            errorMessage: ''
        };
        this.service = AuthenticationService
    }

    inputChanged = e => {
        const state = this.state;
        state[e.target.id] = e.target.value;
        this.setState(state);
    };

    register = () => {
        this.setState({isRegistering: true, errorMessage: ''});
        this.service.register(this.state.firstName, this.state.lastName, this.state.companyName, this.state.role, this.state.telephone, this.state.email, this.state.linkedInProfileUrl)
            .done(() => this.setState({isRegistered: true}))
            .fail(e => this.setState({errorMessage: e.responseText}))
            .always(() => this.setState({isRegistering: false}))
    };

    isValid = () => {
        return this.state.firstName
            && this.state.lastName
            && this.state.companyName
            && this.state.role
            && this.state.telephone
            && this.state.email
            && this.state.confirmEmail
            && this.state.email === this.state.confirmEmail;
    };

    validate = () => {
        if (this.state.email && this.state.confirmEmail && this.state.email !== this.state.confirmEmail) {
            this.setState({errorMessage: 'Email addresses do not match'});
        } else {
            this.setState({errorMessage: ''})
        }
    };

    render() {
        const registered = (
            <div>
                <p>
                    Thank you for registering, we will contact you via the supplied email address following successful
                    completion of the registration process.
                </p>
            </div>);

        const registrationForm = (
            <form className="form-horizontal" style={{marginBottom: '15px'}}>
                <h4 style={{marginBottom: '20px'}}>Application form</h4>
                <p>The members area is a section of our website where selected individuals and organisations are able
                    to view projects that are currently open for investment. If you would like to request access to
                    this section, please complete the form below</p>
                <p style={{marginBottom: '20px'}}>
                    Already a member? Click <a href='javascript:void(0);' onClick={this.props.redirectToLogin}>here</a> to login
                </p>
                <div className="form-group">
                    <label htmlFor="firstName" className="col-sm-2 control-label">First name*</label>
                    <div className="col-sm-10">
                        <input type="text"
                               className="form-control"
                               style={controlMaxWidthStyle}
                               id="firstName"
                               placeholder="First name"
                               value={this.state.firstName}
                               onChange={this.inputChanged}/>
                    </div>
                </div>
                <div className="form-group">
                    <label htmlFor="lastName" className="col-sm-2 control-label">Last name*</label>
                    <div className="col-sm-10">
                        <input type="text"
                               className="form-control"
                               style={controlMaxWidthStyle}
                               id="lastName"
                               placeholder="Last name"
                               value={this.state.lastName}
                               onChange={this.inputChanged}/>
                    </div>
                </div>
                <div className="form-group">
                    <label htmlFor="companyName" className="col-sm-2 control-label">Company name*</label>
                    <div className="col-sm-10">
                        <input type="text"
                               className="form-control"
                               style={controlMaxWidthStyle}
                               id="companyName"
                               placeholder="Company name"
                               value={this.state.companyName}
                               onChange={this.inputChanged}/>
                    </div>
                </div>
                <div className="form-group">
                    <label htmlFor="role" className="col-sm-2 control-label">Role*</label>
                    <div className="col-sm-10">
                        <input type="text"
                               className="form-control"
                               style={controlMaxWidthStyle}
                               id="role"
                               placeholder="Role"
                               value={this.state.role}
                               onChange={this.inputChanged}/>
                    </div>
                </div>
                <div className="form-group">
                    <label htmlFor="telephone" className="col-sm-2 control-label">Telephone*</label>
                    <div className="col-sm-10">
                        <input type="text"
                               className="form-control"
                               style={controlMaxWidthStyle}
                               id="telephone"
                               placeholder="Telephone"
                               value={this.state.telephone}
                               onChange={this.inputChanged}/>
                    </div>
                </div>
                <div className="form-group">
                    <label htmlFor="telephone" className="col-sm-2 control-label">Linked-in profile</label>
                    <div className="col-sm-10">
                        <input type="text"
                               className="form-control"
                               style={controlMaxWidthStyle}
                               id="linkedInProfileUrl"
                               placeholder="Linked In Profile URL"
                               value={this.state.linkedInProfileUrl}
                               onChange={this.inputChanged}/>
                    </div>
                </div>
                <hr style={{margin: '20px 0px 20px 0px'}}/>
                <div className="form-group">
                    <label htmlFor="email" className="col-sm-2 control-label">Email*</label>
                    <div className="col-sm-10">
                        <input type="text"
                               className="form-control"
                               style={controlMaxWidthStyle}
                               id="email"
                               placeholder="Email"
                               value={this.state.email}
                               onChange={this.inputChanged}
                               onBlur={this.validate}/>
                    </div>
                </div>
                <div className="form-group">
                    <label htmlFor="confirmEmail" className="col-sm-2 control-label">Confirm email*</label>
                    <div className="col-sm-10">
                        <input type="text"
                               className="form-control"
                               style={controlMaxWidthStyle}
                               id="confirmEmail"
                               placeholder="Confirm Email"
                               value={this.state.confirmEmail}
                               onChange={this.inputChanged}
                               onBlur={this.validate}/>
                    </div>
                </div>
                <hr style={{margin: '20px 0px 20px 0px'}}/>
                <div className="form-group">
                    <div className="col-sm-offset-2 col-sm-10">
                        {this.state.isRegistering ?
                            <button type="button" className="btn btn-default" disabled>Registering...</button> :
                            this.isValid() ?
                                <button type="button" className="btn btn-default" onClick={this.register}>Register</button> :
                                <button type="submit" className="btn btn-default" disabled>Register</button>}
                    </div>
                </div>
                {this.state.errorMessage ?
                    <div className="col-sm-offset-2 col-sm-10" style={{padding: '4px'}}>
                        <div className="alert alert-danger" style={errorMessageStyle} >{this.state.errorMessage}</div>
                    </div>
                    : undefined}
                <div style={{fontSize: 'x-small'}}>* Required fields</div>
            </form>
        );

        return this.state.isRegistered ? registered : registrationForm;
    }
}


// WEBPACK FOOTER //
// ./src/auth/registration-form.js